import { useState } from 'react'
import { Spinner } from '@material-tailwind/react';
import imageUrl from '../../uploads/Photos/About-Us/AboutUs.webp'
import { Helmet } from 'react-helmet'
import './AboutUs.css'

export default function AboutUs() {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <>
            <Helmet>
                <title>EES | За Нас</title>
                <meta name="title" content="За Нас | Нашата Мисија и Визија" />
                <meta name="description" content="Дознајте повеќе за нашата компанија, мисија, визија и вредности кои нè водат напред." />
                <meta name="keywords" content="за нас, мисија, визија, компанија, вредности" />
            </Helmet>
            <section className="pt-16 pb-9 relative">
                <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
                    <div className="w-full justify-start items-center gap-8 grid lg:grid-cols-2 grid-cols-1">
                        <div className="w-full flex-col justify-start lg:items-start items-center gap-10 inline-flex">
                            <div className="w-full flex-col justify-start lg:items-start items-center gap-4 flex">
                                <h2 className="text-gray-900 text-5xl font-bold font-manrope leading-tight lg:text-start text-center">
                                    За нас
                                </h2>
                                <p className="text-gray-600 text-md font-normal leading-loose lg:text-start text-center">
                                    Компанијата <strong>Енерџи Инженеринг Солушнс</strong> е основана во 2022 година, водена од големата страст кон системите за греење, ладење и климатизација, како и автоматизацијата на истите. Компанијата е формирана од двајца инженери, секој во својот домен на експертиза.
                                </p>

                                <p className="text-gray-600 text-md font-normal leading-loose lg:text-start text-center">
                                <span className="mb-3 text-md">За кратко време, како дистрибутери, успеавме да го покриеме целиот спектар на производи во HVAC секторот:</span>
                                <br /><strong>SAMSUNG</strong> – DX греење, ладење и вентилација  
                                <br /><strong>CLIMAVENETA</strong> – Големи водени ладилни агрегати  
                                <br /><strong>BROFER</strong> – Дистрибутивни елементи  
                                <br /><strong>VORTICE / CASALS</strong> – Вентилатори  
                                <br /><strong>VORTICE INDUSTRIAL</strong> – Клима комори  
                                <br /><strong>SIEMENS</strong> – Автоматизација на HVAC системи  
                                </p>

                                <p className="text-gray-600 text-md font-normal leading-loose lg:text-start text-center">
                                Нашиот пазарен настап опфаќа целосен сегмент на HVAC системите, вклучувајќи дистрибуција, проектирање, инженеринг, изведба, сервисирање, одржување, како и техничка поддршка.
                                </p>

                            </div>
                            <a href="/contact" className="sm:w-fit w-full px-5 py-3 border-gray-800 bg-gray-700 hover:bg-gray-800 transition-all duration-500 ease-in-out rounded-lg shadow-md text-white text-base font-medium text-center">
                                Контактирајте не
                            </a>
                        </div>
                        <div className="relative lg:mx-0 mx-auto h-full rounded-3xl">
                            {!isLoaded && (
                                <div className="absolute inset-0 flex items-center justify-center bg-gray-200 rounded-3xl">
                                <Spinner />
                                </div>
                            )}
                            <img
                                src={imageUrl}
                                alt="About Us"
                                onLoad={() => setIsLoaded(true)}
                                onError={() => setIsLoaded(true)}
                                className={`w-full h-[70vh] object-cover object-left-top rounded-3xl transition-opacity duration-500 ${
                                    isLoaded ? "opacity-100" : "opacity-0"
                                }`}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}